import React, { useState } from 'react';
import Button from './Button';
import Caret from './Caret';
import * as styles from './CollapsibleButton.module.scss';
import LoadingIndicator from './LoadingIndicator';

interface CollapsibleButtonProps {
  collapsed: boolean;
  children: React.ReactNode;
  onClick?: () => Promise<void> | void;
  initialLoading?: boolean;
}

const CollapsibleButton = ({
  collapsed,
  children,
  onClick = () => {},
  initialLoading = false,
}: CollapsibleButtonProps) => {
  const [isLoading, setIsLoading] = useState(initialLoading);

  const handleClick = () => {
    const promise = onClick();

    if (promise?.finally) {
      promise.finally(() => setIsLoading(false));
      setIsLoading(true);
    }
  };

  return (
    <Button variant="link" className={styles.button} onClick={handleClick}>
      {isLoading ? (
        <LoadingIndicator delay={0} />
      ) : (
        <>
          <span className={styles.buttonText}>{children}</span>
          <Caret direction={collapsed ? 'down' : 'up'} />
        </>
      )}
    </Button>
  );
};

export default CollapsibleButton;
